"use strict";
/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = exports.FailedToConnectToStreamrWebSocket = exports.InvalidSubdomainOrToken = exports.DatabaseError = exports.SteamrWebSocketPortMissing = exports.TokenMissing = exports.FailedToExtractIpAddress = exports.UnspecifiedError = exports.Err = exports.ErrorCode = void 0;
const HttpStatus_1 = require("./data/HttpStatus");
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FAILED_TO_EXTRACT_IP_ADDRESS"] = "FAILED_TO_EXTRACT_IP_ADDRESS";
    ErrorCode["UNSPECIFIED_ERROR"] = "UNSPECIFIED_ERROR";
    ErrorCode["TOKEN_MISSING"] = "TOKEN_MISSING";
    ErrorCode["STREAMR_WEBSOCKET_PORT_MISSING"] = "STREAMR_WEBSOCKET_PORT_MISSING";
    ErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    ErrorCode["INVALID_SUBDOMAIN_OR_TOKEN"] = "INVALID_SUBDOMAIN_OR_TOKEN";
    ErrorCode["FAILED_TO_CONNECT_TO_STREAMR_WEBSOCKET"] = "FAILED_TO_CONNECT_TO_STREAMR_WEBSOCKET";
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
// TODO: fix name, probably only used by server?
class Err extends Error {
    code;
    // TODO: could remove httpStatus since we already have a higher level error?
    httpStatus;
    originalError;
    constructor(code, httpStatus, message, originalError) {
        super(message);
        this.code = code;
        this.httpStatus = httpStatus;
        this.originalError = originalError;
    }
    toApiError() {
        return {
            code: this.code,
            message: this.message
        };
    }
}
exports.Err = Err;
// TODO: many of these errors are used from 'autocertifier-server' and not in this package, should be moved there
class UnspecifiedError extends Err {
    constructor(message, originalError) { super(ErrorCode.UNSPECIFIED_ERROR, HttpStatus_1.HttpStatus.INTERNAL_SERVER_ERROR, message, originalError); }
}
exports.UnspecifiedError = UnspecifiedError;
class FailedToExtractIpAddress extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_EXTRACT_IP_ADDRESS, HttpStatus_1.HttpStatus.INTERNAL_SERVER_ERROR, message, originalError); }
}
exports.FailedToExtractIpAddress = FailedToExtractIpAddress;
class TokenMissing extends Err {
    constructor(message, originalError) { super(ErrorCode.TOKEN_MISSING, HttpStatus_1.HttpStatus.BAD_REQUEST, message, originalError); }
}
exports.TokenMissing = TokenMissing;
class SteamrWebSocketPortMissing extends Err {
    constructor(message, originalError) { super(ErrorCode.STREAMR_WEBSOCKET_PORT_MISSING, HttpStatus_1.HttpStatus.BAD_REQUEST, message, originalError); }
}
exports.SteamrWebSocketPortMissing = SteamrWebSocketPortMissing;
class DatabaseError extends Err {
    constructor(message, originalError) { super(ErrorCode.DATABASE_ERROR, HttpStatus_1.HttpStatus.INTERNAL_SERVER_ERROR, message, originalError); }
}
exports.DatabaseError = DatabaseError;
class InvalidSubdomainOrToken extends Err {
    constructor(message, originalError) { super(ErrorCode.INVALID_SUBDOMAIN_OR_TOKEN, HttpStatus_1.HttpStatus.UNAUTHORIZED, message, originalError); }
}
exports.InvalidSubdomainOrToken = InvalidSubdomainOrToken;
class FailedToConnectToStreamrWebSocket extends Err {
    constructor(message, originalError) { super(ErrorCode.FAILED_TO_CONNECT_TO_STREAMR_WEBSOCKET, HttpStatus_1.HttpStatus.INTERNAL_SERVER_ERROR, message, originalError); }
}
exports.FailedToConnectToStreamrWebSocket = FailedToConnectToStreamrWebSocket;
class ServerError extends Err {
    constructor(originalError) {
        super(ErrorCode.SERVER_ERROR, originalError.httpStatus, originalError.message, originalError);
    }
}
exports.ServerError = ServerError;
//# sourceMappingURL=errors.js.map